module.exports = __webpack_public_path__ + "img/safety-1.de2ba2a1.jpg";